// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__W2LmO","disabled":"FileBtn_disabled__3HWHK","warn":"FileBtn_warn__1jBUa","fade":"FileBtn_fade__18SS9"};